import { defineStore } from 'pinia';
import { ref } from 'vue';

const useSettingsStore = defineStore('settings', () => {
    const debugMode = ref(false);

    function setDebugMode(on) {
        debugMode.value = on;
    }

    return {
        debugMode,
        setDebugMode
    };
});

export { useSettingsStore };
